import { FC } from 'react';
import { useTranslation } from 'next-i18next';

import Icon from 'src/common/components/Icon';
import DetailsList from 'src/listing/components/DetailsList';
import { usePreviewModeContext } from 'src/common/providers/PreviewModeProvider';

import styles from './BoatCapacity.module.scss';

type BoatCapacityProps = {
  capacity: number;
};

const BoatCapacity: FC<BoatCapacityProps> = ({
  capacity,
}) => {
  const [t] = useTranslation(['listing-page', 'admin-listing-preview']);
  const { previewMode } = usePreviewModeContext();
  const showPlaceholder = previewMode && capacity <= 0;

  if (!previewMode && capacity <= 0) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Icon
        id="listing/icon-group"
        className={styles.icon}
      />
      <DetailsList
        details={[{
          termIsProminent: false,
          term: t('capacity'),
          description: showPlaceholder
            ? t('admin-listing-preview:guest-capacity--placeholder')
            : t('guestCapacity', { count: capacity }),
        }]}
      />
    </div>
  );
};

export default BoatCapacity;
